/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, EventEmitter, Input, Output, ViewChildren } from '@angular/core';
import { InitiativeMetadata } from '../../lib/wwg.classes';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';

@Component({
  selector: 'wwg-metadata',
  templateUrl: './metadata.component.html',
  styleUrls: ['./metadata.component.scss']
})

export class MetadataComponent {

  @ViewChildren(AutocompleteComponent) autocompleteComponents;

  private _model: InitiativeMetadata;
  public autocomplete = ['sgx_issuer_name'];

  @Input() get model() {
    return this._model;
  }
  @Output() modelChange = new EventEmitter();

  set model(val) {
    this._model = val;
    this.modelChange.emit(this._model);
  }

  metadataNames(): string[] {
    return Object.keys(InitiativeMetadata.withEmptyValues());
  }

  public addMetadata() {
    if (!this.model) {
      this.model = new InitiativeMetadata();
    }
  }
}
